import { JobType } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

export const JobTypeService = (() => {
  let dotNetObj: DotNetObject;
  let cachedJobTypes: JobType[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobTypes = async (useCache: boolean = true): Promise<JobType[]> => {
    if (useCache && cachedJobTypes != null)
      return cachedJobTypes;

    if (dotNetObj) {
      cachedJobTypes = await dotNetObj.invokeMethodAsync<JobType[]>('GetAsync');
      return cachedJobTypes;
    } else {
      throw 'Job Type DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobTypes,
  };
})();
